import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PageStore } from "../../shared/providers/page";
import { RouteRedirector } from "../../shared/providers/routeRedirector";
import { EmitterService } from '../shared/emitterService';
import { ConfPageSessionService } from "./confPageSessionService";
import { ConfRouteParams } from './confRouteParams';

@Injectable()
export class ConfDataLoadedGuard implements CanActivate {

  constructor(public router: Router, public activeRoute: ActivatedRoute, public confPageSession: ConfPageSessionService, public pageStore: PageStore, public redirector: RouteRedirector, private emitterService: EmitterService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    //let paramMap: any = route.firstChild.paramMap;
    let params: ConfRouteParams = { ...route.params };

    // Set the current view
    params.view = <any>route.url[0].path;

    let loaded: boolean = this.confPageSession.dataLoaded;

    let subConfId = (<any>params).subconfid;

    // If a subConfId is provided in the URL, verify whether its data has been loaded. The data might not be accessible if the pageId has not been set yet.
    if (subConfId && this.confPageSession.pageId) {
      const sessionId = this.confPageSession.confSessionId;
      const info = this.confPageSession.confStore.getConfInfo(+subConfId, sessionId);
      loaded = info != null; // allow activation only if found
    }

    if (loaded && this.pageStore.activeRouteName == params.view)
      return true;
    
    this.redirector.redirectToDataLoaderComponent(params, null, +subConfId);

    /*else */

    return false;
  }
}